import { FilterOptionsState } from '@mui/material';
import { Option } from 'shared-ui';

import { QueryKeyEnum } from 'core/global.enum';
import { useQuery } from 'hooks/useQuery/useQuery';
import { AnnouncementsIdSortEnum } from 'context/query/queryContext/QueryContext.enum';
import { fetchAllSchedulesNames } from 'api/schedules/schedules';
import * as Styled from '../TableSearch.styles';

export const useSearchBySchedules = (optionsQuery: string, isEnabled: boolean) => {
  const { data: schedulesResponse, isInitialLoading } = useQuery(
    [QueryKeyEnum.SCHEDULES_SEARCH, optionsQuery],
    () => fetchAllSchedulesNames(),
    {
      args: {
        sort: [AnnouncementsIdSortEnum.ASC],
        query: optionsQuery,
      },
      enabled: isEnabled,
    },
  );

  const schedules = schedulesResponse?.data || [];

  const createOptions = () => {
    return schedules.map((schedule) => ({
      value: schedule,
      label: schedule,
    }));
  };

  const filterOptions = (options: Option[], { inputValue }: FilterOptionsState<Option>) => {
    const standarizedInputValue = inputValue.toLowerCase();

    return options.filter(
      ({ label, value }) =>
        label.toLowerCase().includes(standarizedInputValue) || `${value}`.toLowerCase().includes(standarizedInputValue),
    );
  };

  const createOptionLabel = (optionProps: React.HTMLAttributes<HTMLLIElement>, option: Option) => {
    return (
      <li {...optionProps} key={`${option.value}-${Math.random()}`}>
        <Styled.OptionLabel sx={{ py: 0.7 }}>{option.label}</Styled.OptionLabel>
      </li>
    );
  };

  return { isLoading: isInitialLoading, createOptions, createOptionLabel, filterOptions };
};
